import { Theme } from '@mui/material/styles';

// ----------------------------------------------------------------------

export default function Button(theme: Theme) {
  return {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none' as const,
          '&:hover': {
            boxShadow: 'none',
          },
        },
      },
      variants: [
        {
          props: { size: 'medium' as const },
          style: { height: 40 },
        },
        {
          props: { size: 'large' as const },
          style: { height: 48 },
        },
        {
          props: { variant: 'contained' as const, color: 'inherit' as const },
          style: {
            color: theme.palette.grey[800],
            boxShadow: 'none',
            '&:hover': {
              backgroundColor: theme.palette.grey[400],
            },
          },
        },
        {
          props: { variant: 'contained' as const, color: 'primary' as const },
          style: {
            color: 'white',
            boxShadow: 'none',
          },
        },
        {
          props: { variant: 'contained' as const, color: 'secondary' as const },
          style: { boxShadow: 'none' },
        },
        {
          props: { variant: 'contained' as const, color: 'info' as const },
          style: { boxShadow: 'none' },
        },
        {
          props: { variant: 'contained' as const, color: 'success' as const },
          style: { boxShadow: 'none' },
        },
        {
          props: { variant: 'contained' as const, color: 'warning' as const },
          style: { boxShadow: 'none' },
        },
        {
          props: { variant: 'contained' as const, color: 'error' as const },
          style: { boxShadow: 'none' },
        },
        {
          props: { variant: 'outlined' as const, color: 'inherit' as const },
          style: {
            border: `1px solid ${theme.palette.grey[500_32]}`,
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
        {
          props: { variant: 'text' as const, color: 'inherit' as const },
          style: {
            '&:hover': {
              backgroundColor: theme.palette.action.hover,
            },
          },
        },
      ],
    },
  };
}
